<!-- 全局登录组件  ———李丁 -->
<template>
  <div>
    <el-dialog custom-class="loginBox" title="植保学院仪器共享平台" :before-close="handleClose" :close-on-click-modal="false"
      :visible.sync="showLogin" :modal-append-to-body='false' :append-to-body="true">
      <el-form ref="form" :model="loginForm" :rules="rules">
        <el-form-item label="账号登录" prop="username">
          <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="请输入账号">
            <template slot="prepend"><i class="el-icon-user"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" show-password>
            <template slot="prepend"><i class="el-icon-lock"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item class="loginButtonbox">
          <el-button type='primary' @click='doLogin(loginForm)'>登录</el-button>
        </el-form-item>
      </el-form>
      <div class="tipregis"><span>还没有账号？</span><el-button type="text" @click="goRegister">立即注册</el-button></div>
    </el-dialog>
    <register v-if="showRegister" :showRegister="showRegister" @close="showRegister = false"></register>
  </div>
</template>
<script>
import { Encrypt } from "@/utils/encryp";
export default {
  name: 'login',
  props: {
    showLogin: {
      default: false
    },
  },
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: ["blur", 'change'] },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: ["blur", 'change'] },
        ],
      },
      showRegister: false,
    };
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    doLogin(loginForm) {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let form = {
            "username": loginForm.username,
            "password": Encrypt(loginForm.password),
            "uuid": "",
            "validCode": false
          };
          this.$store.dispatch('user/login', form).then((res) => {
            if (res.code == 200) {
              this.handleClose();
              this.$message({
                type: "success",
                message: "登录成功"
              });
              this.$store.dispatch('user/setUsrmsg');
              this.$net(`/sdau/userClient/appraisal/queryAdmissionExamPaper`, 'get').then(res => {
                window.localStorage.setItem('Examination', res.data.open ? !res.data.pass : res.data.open);
                setTimeout(() => {
                  location.reload();
                }, 500);
              }).catch(err => {
                setTimeout(() => {
                  location.reload();
                }, 500);
              })
            }
          });
        }
      });
    },
    goRegister() {
      this.showRegister = true
    },

  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__title {
  font-size: 20px;
  font-weight: 600;
}

::v-deep .loginBox {
  width: 496px;
  height: 520px;
  border: 1px solid #d7dce0;
  opacity: 1;
  padding: 20px 20px 0 20px;

  .el-form-item__label {
    font-size: 16px;
    font-weight: 500;
  }

  .el-form-item__label::before {
    display: none;
  }

  .loginButtonbox {

    .el-button {
      width: 416px;
      height: 48px;
      margin-top: 50px;
    }
  }



  .el-form-item__error {
    padding-left: 55px;
  }
}

.tipregis {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
</style>

